import styled from 'styled-components/macro';

import { mediaDesktop } from 'breakpoints';
import theme from 'components/theme';
import Typography from 'components/Typography';

export const StyledTextArticle = styled.div`
  text-align: center;
  ${mediaDesktop} {
    margin: auto;
    max-width: 825px;
  }
`;

export const StyledArticleHeadline = styled(Typography)`
  margin-top: 10px;
  margin-bottom: 7px;
  letter-spacing: 1px;

  ${mediaDesktop} {
    margin-top: 0;
    margin-bottom: 13px;
    line-height: 48px;
    font-size: 40px;
    letter-spacing: 2px;
  }
`;
export const StyledArticleDescription = styled(Typography)`
  line-height: 19px;
  letter-spacing: normal;
  font-family: ${theme.fonts.primary};
  font-size: 16px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;

  ${mediaDesktop} {
    padding: 0 13px;
    font-size: 21px;
    line-height: 25px;
    letter-spacing: 1px;
  }
`;

export const StyledArticleRelease = styled(Typography)`
  display: none;

  ${mediaDesktop} {
    display: block;
    margin: 14px 0 0px;
    font-size: 21px;
  }
`;

export const StyledIframeContainer = styled.div`
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
  border: 1px solid ${theme.colors.primary};
  box-sizing: border-box;
  margin-top: 20px;

  &:after {
    content: '';
    display: block;
    padding-top: 56.25%;

  }

  ${mediaDesktop} {
    margin-top: 48px;
    max-width: 764px;
    max-height: 428px;
    border-width: 2px;
  }
`;

export const StyledIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  padding: 10px;

  ${mediaDesktop} {
    padding: 20px
  }
`;

export const StyledInfoSection = styled.section`
  display: block;
  background: ${theme.colors.dark};
  padding: 26px 24px 26px;

  ${mediaDesktop} {
    padding: 102px 100px 100px;
    text-align: center;
  }

  ${StyledArticleDescription} + ${StyledArticleDescription} {
    margin-top: 12px;

    ${mediaDesktop} {
      margin-top: 12px;
    }
  }

  ${StyledTextArticle} + ${StyledTextArticle} {
    margin-top: 22px;

    ${mediaDesktop} {
      margin-top: 50px;
    }
  }
`;

export const StyledViewMore = styled.span<{ $hide: boolean }>`
  cursor: pointer;
  ${({ $hide }) => ($hide ? { display: 'none' } : { display: 'inline-block' })};

  text-decoration: underline;
  font-size: 16px;
  font-weight: bolder;
  ${mediaDesktop} {
    font-size: 21px;
  }
  &:hover {
    color: ${theme.colors.textGray};
  }
`;
